<script lang="ts" context="module">
	declare global {
		interface Window {
			grecaptcha: {
				execute(widgetId?: string): Promise<void>;
				reset(widgetId?: string): void;
				getResponse(widgetId?: string): string;
				ready(cb: () => void): void;
				render(container: Element, parameters: { sitekey: string; size: "invisible" }): string;
			};
		}
	}
</script>

<script lang="ts">
	import { handleInvalidInputs } from "./handleInvalidInputs.js";
	import { getGlobalSettings } from "../../getGlobalSettings.js";

	export let enableRecaptcha = false;
	export let form: HTMLFormElement | null = null;
	export let onsubmit: ((event: SubmitEvent) => void) | undefined = undefined;

	const { RECAPTCHA_SITE_KEY } = getGlobalSettings();

	let formClass = "";
	export { formClass as class };

	let ready = false;
	async function waitForReadyRecatpcha(): Promise<void> {
		if (ready) {
			return;
		}
		await new Promise((resolve) => {
			setInterval(() => {
				if (ready) {
					resolve(undefined);
				}
			}, 500);
		});
	}

	let widgetId: string | undefined;
	async function handleAntispamSubmit(event: SubmitEvent): Promise<void> {
		event.preventDefault();

		if (!enableRecaptcha) {
			onsubmit?.(event);
			return;
		}

		await waitForReadyRecatpcha();
		await window.grecaptcha.execute(widgetId);
		const token = window.grecaptcha.getResponse(widgetId);
		if (token) {
			window.grecaptcha.reset();
			onsubmit?.(event);
		}
	}

	function recaptcha(element: HTMLElement): void {
		widgetId = window.grecaptcha.render(element, {
			sitekey: RECAPTCHA_SITE_KEY,
			size: "invisible",
		});
		window.grecaptcha.ready(() => {
			ready = true;
		});
	}
</script>

<form bind:this={form} class={formClass} on:submit={handleAntispamSubmit} use:handleInvalidInputs on:change on:input>
	{#if enableRecaptcha}
		<div use:recaptcha></div>
	{/if}

	<slot />
</form>
